// extracted by mini-css-extract-plugin
export var addButton = "_ph-0";
export var border = "_ph-8";
export var check = "_ph-h";
export var danger = "_ph-6";
export var dropdownContainer = "_ph-1";
export var editModalBody = "_ph-j";
export var footerContainer = "_ph-i";
export var fullWidth = "_ph-a";
export var hide = "_ph-9";
export var icon = "_ph-3";
export var input = "_ph-7";
export var inputFlex = "_ph-b";
export var inputWrapper = "_ph-c";
export var manualFocus = "_ph-5";
export var optionButton = "_ph-4";
export var pillWrapper = "_ph-e";
export var pointer = "_ph-2";
export var showOverflow = "_ph-f";
export var tagsFlex = "_ph-d";
export var xButton = "_ph-g";